import { useMutation } from "react-query";

import { updateClientDiagnosis } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpdateClientDiagnosis = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }) => updateClientDiagnosis(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while updating the diagnosis.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    updateClientDiagnosisMutation: mutate,
    isUpdateClientDiagnosisLoading: isLoading,
    ...rest,
  };
};
